import { Reducer } from "redux";
import { produce } from "immer";

import { PROJECT_DEVIATION_SUMMARY_LOADED, ProjectDeviationSummaryLoadedEvent } from "../../../events/loaded/projects/project_deviation_summary_loaded";

import type { ApiProjectDeviationSummary } from "avvir";

export type ProjectDeviationSummariesStore = {
  byFirebaseProjectId: { [projectId: string]: ApiProjectDeviationSummary }
}

const reduceProjectDeviationSummaries: Reducer<ProjectDeviationSummariesStore, ProjectDeviationSummaryLoadedEvent> = (
  summaries: ProjectDeviationSummariesStore = { byFirebaseProjectId: {} },
  event
) => {
  return produce<ProjectDeviationSummariesStore>(summaries, (draft) => {
    if (!draft.byFirebaseProjectId) {
      draft.byFirebaseProjectId = {};
    }
    switch (event.type) {
      case PROJECT_DEVIATION_SUMMARY_LOADED: {
        draft.byFirebaseProjectId[event.payload.projectId] = event.payload.summary;
        return draft;
      }
      default: {
        return draft;
      }
    }
  });
};

export default reduceProjectDeviationSummaries;
